module.exports = __webpack_public_path__ + "img/icon-shouye-s.049e60d1.png";